module.exports = __webpack_public_path__ + "img/征和.png";